function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4673 0C16.3794 0 14.3995 0.855852 12.9775 2.36937C11.5556 0.86486 9.58462 0 7.5147 0C3.37487 0 0 3.36937 0 7.51348V17H4V7.51348C4 5.79285 5.46279 4.32432 7.12772 4.15315C7.24471 4.14414 7.36172 4.13513 7.46971 4.13513C9.34163 4.13513 10.991 5.63957 11 7.51348V17H15.0204V7.51348C15.0204 5.80185 16.4244 4.31532 18.0983 4.14414C18.2153 4.13513 18.3323 4.12612 18.4403 4.12612C20.3122 4.12612 21.991 5.64858 22 7.51348V17H26V7.51348C26 5.61267 25.298 3.9009 24.0291 2.48648C22.7601 1.06306 21.0232 0.189193 19.1333 0.0270262C18.9083 0.00900908 18.6922 0 18.4673 0Z"
});

function SvgMollie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMollie);
export default __webpack_public_path__ + "static/media/mollie.c7132367.svg";
export { ForwardRef as ReactComponent };